import { Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import ReactSelect from "react-select";
import SoftTypography from "components/SoftTypography";
import toast from "react-hot-toast";
import PrimaryButton from "../../../components/PrimaryButton";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import "../../plansCompact.css";

const ConfigrationForm = ({ editdata, onClose, handleRefresh, handleRefereshpricing, data }) => {
  const [step, setStep] = useState(1);
  const [loader, setLoader] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [promplabels, setpromplabels] = useState([]);
  const [isFreeSaas, setIsFreeSaas] = useState(editdata?.is_free_saas);
  const [addTagModel, setAddTagModel] = useState(false);
  const [addCategoryModel, setAddCategoryModel] = useState(false);
  const [categoryFormData, setCategoryFormData] = useState([]);
  const [googleMap, setgoogleMap] = useState(false);
  const [reviewsCheck, setReviewsCheck] = useState(false);
  const [BusinessHourCheck, setBusinessHourCheck] = useState(false);
  const [videoUploadCheck, setVideoUploadCheck] = useState(false);
  const [imageSliderCheck, setImageSliderCheck] = useState(false);
  const [CompanyLogoCheck, setCompanyLogoCheck] = useState(false);
  const [ScheduledDayCheck, setScheduledDayCheck] = useState(false);
  const [VideoCheck, setVideoCheck] = useState(false);
  const [extraLinksCheck, setextraLinksCheck] = useState(false);
  const [ShortcodeCheck, setShortcodeCheck] = useState(false);
  const [SocialmediaCheck, setSocialmediaCheck] = useState(false);
  const [customBlogsCheck, setcustomBlogsCheck] = useState(false);
  const [promoVideoCheck, setpromoVideoCheck] = useState(false);
  const [gmbseoCheck, setgmbseoCheck] = useState(false);
  const [gmbprofileCheck, setgmbprofileCheck] = useState(false);
  const [addonsData, setAddonsData] = useState([]);
  const [editFeatureModal, setEditFeatureModal] = useState(false);
  const [featureToEdit, setFeatureToEdit] = useState(null);
  const [tempFeatureName, setTempFeatureName] = useState("");
  const [tempFeatureDescription, setTempFeatureDescription] = useState("");

  const moveFeature = (fromIndex, toIndex) => {
    if (toIndex < 0 || toIndex >= formData.features.length) return;

    const updatedFeatures = [...formData.features];
    const [movedItem] = updatedFeatures.splice(fromIndex, 1);
    updatedFeatures.splice(toIndex, 0, movedItem);

    setFormData((prev) => ({
      ...prev,
      features: updatedFeatures,
    }));
  };

  const googleMapchanger = () => {
    setgoogleMap(!googleMap);
  };
  const reviewsChanger = () => {
    setReviewsCheck(!reviewsCheck);
  };

  const BusinessHourChanger = () => {
    setBusinessHourCheck(!BusinessHourCheck);
  };

  const videoUploadChanger = () => {
    setVideoUploadCheck(!videoUploadCheck);
  };

  const imageSliderChanger = () => {
    setImageSliderCheck(!imageSliderCheck);
  };

  // sdg

  const companyLogo = () => {
    setCompanyLogoCheck(!CompanyLogoCheck);
  };
  const ScheduledDay = () => {
    setScheduledDayCheck(!ScheduledDayCheck);
  };
  const VideoChanger = () => {
    setVideoCheck(!VideoCheck);
  };
  const ExtraLinksChanger = () => {
    setextraLinksCheck(!extraLinksCheck);
  };
  const ShortcodeChanger = () => {
    setShortcodeCheck(!ShortcodeCheck);
  };
  const socialMediaChanger = () => {
    setSocialmediaCheck(!SocialmediaCheck);
  };
  const customBlogsChanger = () => {
    setcustomBlogsCheck(!customBlogsCheck);
  };
  const promoVideoChanger = () => {
    setpromoVideoCheck(!promoVideoCheck);
  };
  const gmbseoChanger = () => {
    setgmbseoCheck(!gmbseoCheck);
  };
  const gmbprofileChanger = () => {
    setgmbprofileCheck(!gmbprofileCheck);
  };

  const [hasFreeSaasPlan, setHasFreeSaasPlan] = useState(false);
  const [formData, setFormData] = useState({
    ...editdata,
    _id: editdata._id,
    plan: {
      planName: editdata.plan.planName || "",
      description: editdata.plan.description || "",
    },
    is_free_saas: editdata.is_free_saas || false,
    category: {
      categorySelected: editdata.category?.categorySelected || null,
      categoryOptions: editdata.category?.categoryOptions || null,
    },
    pricing: {
      monthly_price: editdata.monthly_amount ? parseInt(editdata.monthly_amount) / 100 : 0,
      yearly_price: editdata.yearly_amount ? parseInt(editdata.yearly_amount) / 100 : 0,
      user_limit: parseInt(editdata.user_limit || 0),
      contact_limit: 0, // Assuming this is not provided in editdata
    },
    apps: {
      snapshotselected: [], // Assuming how to handle apps isn't defined
      promptlabel_ids: [], // Assuming no initial data
    },
    trial_and_credit: {
      active_trile_period: editdata.trial_and_credit?.active_trile_period || false,
      add_credit: editdata.trial_and_credit?.add_credit || false,
      days: parseInt(editdata.trial_and_credit?.days || 0),
      credit_amount: parseInt(editdata.trial_and_credit?.credit_amount || 0),
    },
    rebilling: {
      ai_active: editdata.rebilling?.ai_active || false,
      markupmargin: editdata.rebilling?.markupmargin || 1,
    },
    agency: {
      id: agency._id,
    },
    features: (() => {
      const mapped = (editdata.features || []).map((f) => ({
        ...f,
        showInPlan: f.showInPlan !== false,
      }));

      const hasCustomCode = mapped.some((f) => f.name === "Custom code embed");
      const hasDeals = mapped.some((f) => f.name === "Deals");

      const result = [...mapped];

      if (!hasCustomCode) {
        result.push({
          name: "Custom code embed",
          showName: "Custom code embed",
          value: false,
          showInPlan: true,
        });
      }

      if (!hasDeals) {
        result.push({
          name: "Deals",
          showName: "Deals",
          value: false,
          showInPlan: true,
        });
      }

      return result;
    })(),
    external: editdata?.external,
    custom_redirect: editdata?.custom_redirect || false,
    custom_redirect_url: editdata?.custom_redirect_url || "",
    monthly_url: editdata?.monthly_url,
    yearly_url: editdata?.yearly_url,
    currency: editdata.currency || "usd",
    currency_symbol: editdata.currency_symbol || "$",
    badge_label: editdata?.badge_label || "",
    highlight_color: editdata?.highlight_color || "",
    highlight_bg_color: editdata?.highlight_bg_color || "",
  });

  const openEditFeatureModal = (index) => {
    const feature = formData.features[index];

    if (feature._id) return; // addons cannot be edited

    setFeatureToEdit({ index, ...feature });
    setTempFeatureName(feature.showName || feature.name);
    setTempFeatureDescription(feature.description || "");
    setEditFeatureModal(true);
  };

  const saveFeatureName = () => {
    if (!featureToEdit) return;

    setFormData((prev) => {
      const updated = [...prev.features];
      updated[featureToEdit.index] = {
        ...updated[featureToEdit.index],
        showName: tempFeatureName,
        description: tempFeatureDescription,
      };
      return { ...prev, features: updated };
    });

    setEditFeatureModal(false);
  };

  useEffect(() => {
    async function fetchData() {
      const response = await AppService.saas.fetch_addons({ query: `agency_id=${agency?._id}` });
      const addons = response?.response?.data || [];
      setAddonsData(addons);

      setFormData((prevData) => {
        const addonsMap = new Map(addons.map((addon) => [addon._id, addon]));

        const updatedFeatures = prevData.features
          .filter((feature) => !feature._id || addonsMap.has(feature._id))
          .map((feature) =>
            feature._id
              ? {
                  ...feature,
                  name: addonsMap.get(feature._id).name,
                  showInPlan: feature.showInPlan !== false,
                }
              : { ...feature, showInPlan: feature.showInPlan !== false }
          );

        const newAddons = addons
          .filter((addon) => !prevData.features.some((f) => f._id === addon._id))
          .map((addon) => ({
            _id: addon._id,
            name: addon.name,
            value: false,
            showInPlan: true,
          }));

        let nextFeatures = [...updatedFeatures, ...newAddons];
        if (!nextFeatures.some((f) => f.name === "Custom code embed")) {
          nextFeatures = [
            ...nextFeatures,
            {
              name: "Custom code embed",
              showName: "Custom code embed",
              value: false,
              showInPlan: true,
            },
          ];
        }

        return {
          ...prevData,
          features: nextFeatures,
        };
      });
    }

    fetchData();
  }, []);

  const updateFeatureInFormData = (index) => {
    setFormData((prevData) => {
      const newFeatures = [...prevData.features];
      newFeatures[index].value = !newFeatures[index].value;
      return { ...prevData, features: newFeatures };
    });
  };

  console.log(addonsData, "addonsData1234");

  console.log(formData.features, "formData");

  const [errors, setErrors] = useState({});
  const validateStep1 = () => {
    const step1Errors = {};
    if (!formData.plan.planName.trim()) {
      step1Errors.planName = "Plan Name is required";
    }
    if (!formData.plan.description.trim()) {
      step1Errors.description = "Description is required";
    }
    if (formData.external && formData.pricing.monthly_price && !formData.monthly_url) {
      step1Errors.monthly_url = "Monthly url is required";
    }
    if (formData.external && formData.pricing.yearly_price && !formData.yearly_url) {
      step1Errors.yearly_url = "Yearly url is required";
    }
    if (formData.custom_redirect && !formData.custom_redirect_url) {
      step1Errors.custom_redirect_url = "Custom redirect url is required";
    }
    setErrors(step1Errors);
    return Object.keys(step1Errors).length === 0;
  };
  const handleNext = () => {
    if (step === 1 && validateStep1()) {
      setStep(step + 1);
    } else if (step === 2) {
      setStep(step + 1);
    } else if (step === 3) {
      setStep(step + 1);
    } else if (step === 4) {
      setStep(step + 1);
    } else if (step === 5) {
      setStep(step + 1);
    } else if (step === 6) {
      setStep(step + 1);
    }
  };

  const handleCustomTab = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // setLoader(true)
    try {
      // Handle form submission logic here
      const payload = { ...formData };

      // const isFreePlan =
      //         hasFreeSaasPlan &&
      //         (!formData.pricing.monthly_price || formData.pricing.monthly_price === 0) &&
      //         (!formData.pricing.yearly_price || formData.pricing.yearly_price === 0);

      //       if (isFreePlan) {
      //         toast.error("You already have a free plan. Please add a monthly or annual amount!");
      //         setLoader(false);
      //         return;
      //       }
      // return 0
      const { response, error } = await AppService.saas.updateSaasConfigration({ payload });

      // return 0
      if (response) {
        onClose();
        handleRefresh();
        // window.location.reload()
        toast.success("Plan updated successfully!");
      } else {
        toast.error(error?.message || "Error updating Plan");
      }
      setLoader(false);
    } catch {
      setLoader(false);
    }
  };
  const handleSelectChange_of_Category = (option) => {
    setFormData({
      ...formData,
      category: { ...formData.category, categoryOptions: option.value },
      category: { ...formData.category, categorySelected: option.value },
    });
  };

  const handleToggleChange_toggle_phone_system_reselling = (event) => {
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, ai_active: event.target.checked },
    });
  };

  const handleToggleFeature = (index) => {
    setFormData((prevState) => {
      const updatedFeatures = [...prevState.features];
      updatedFeatures[index].value = !updatedFeatures[index].value;

      return { ...prevState, features: updatedFeatures };
    });
  };

  const handleToggleShowInPlan = (index) => {
    setFormData((prevState) => {
      const updatedFeatures = [...prevState.features];
      const cur = updatedFeatures[index];
      const visible = cur.showInPlan !== false;
      updatedFeatures[index] = {
        ...cur,
        showInPlan: !visible,
      };
      return { ...prevState, features: updatedFeatures };
    });
  };

  const celenderappchanger = () => {
    setcelenderchanger(!celenderchanger);
    let updatedSnapshotSelected = [...formData.apps.snapshotselected];
    if (!celenderchanger) {
      // If celenderchanger is false, we are about to set it to true, so we push the value
      updatedSnapshotSelected.push("AI Celender App");
    } else {
      // If celenderchanger is true, we are about to set it to false, so we remove the value
      updatedSnapshotSelected = updatedSnapshotSelected.filter(
        (item) => item !== "AI Celender App"
      );
    }
    setFormData({
      ...formData,
      apps: { ...formData.apps, snapshotselected: updatedSnapshotSelected },
    });
  };

  const savedataPromptLabel = async (formData) => {
    const updatedFormData = {
      ...formData,
      agency_id: agency._id,
      type: "agency",
    };
    const payload = updatedFormData;
    //
    const { response } = await AppService.promptslabel.create({
      payload,
      toaster: true,
    });
    if (response) {
      handleclose();
      setAddTagModel(false);
      onLoad();
    }
  };
  const handleclose = () => {
    setAddTagModel(false);
  };
  const handleAddTag = () => {
    setAddTagModel(true);
  };
  const handleAddCategory = () => {
    setAddCategoryModel(true);
  };

  const handleFeatureToggle = (featureName) => {
    setFormData((prevData) => ({
      ...prevData,
      features: prevData.features.map((feature) =>
        feature.name === featureName ? { ...feature, value: !feature.value } : feature
      ),
    }));
  };

  const savecategory = async () => {
    categoryFormData.agency_id = agency._id;
    const payload = categoryFormData;
    console.log(payload);
    const { response } = await AppService.saas.categorypricing({ payload });
    if (response) {
      setAddCategoryModel(false);
      setCategoryFormData([]);
      onLoad();
    }
  };

  const Change_of_currency = (option) => {
    // setCategoryFormData({
    //   ...categoryFormData,
    //   currency: option.value,
    // });

    setFormData({
      ...formData,
      currency: option.value,
      currency_symbol: option.label.split(" ")[0],
    });
  };
  const availableCRNC = [
    { value: "usd", label: "$ USD" },
    { value: "eur", label: "€ Euro" },
    { value: "jpy", label: "¥ Japanese Yen" },
    { value: "gbp", label: "£ British Pound Sterling" },
    { value: "aud", label: "$ Australian Dollar" },
    { value: "cad", label: "$ Canadian Dollar" },
    { value: "chf", label: "Fr Swiss Franc" },
    { value: "cny", label: "¥ Chinese Yuan" },
    { value: "hkd", label: "HK$ Hong Kong Dollar" },
    { value: "nzd", label: "$ New Zealand Dollar" },
    { value: "sek", label: "kr Swedish Krona" },
    { value: "krw", label: "₩ South Korean Won" },
    { value: "sgd", label: "S$ Singapore Dollar" },
    { value: "nok", label: "kr Norwegian Krone" },
    { value: "mxn", label: "$ Mexican Peso" },
    { value: "inr", label: "₹ Indian Rupee" },
    { value: "rub", label: "₽ Russian Ruble" },
    { value: "zar", label: "R South African Rand" },
    { value: "brl", label: "R$ Brazilian Real" },
    { value: "try", label: "₺ Turkish Lira" },
    { value: "idr", label: "Rp Indonesian Rupiah" },
    { value: "thb", label: "฿ Thai Baht" },
    { value: "pln", label: "zł Polish Zloty" },
    { value: "php", label: "₱ Philippine Peso" },
    { value: "czk", label: "Kč Czech Koruna" },
    { value: "myr", label: "RM Malaysian Ringgit" },
    { value: "huf", label: "Ft Hungarian Forint" },
    { value: "isk", label: "kr Icelandic Króna" },
    { value: "hrk", label: "kn Croatian Kuna" },
    { value: "dkk", label: "kr Danish Krone" },
    { value: "ils", label: "₪ Israeli Shekel" },
    { value: "ars", label: "$ Argentine Peso" },
    { value: "clp", label: "$ Chilean Peso" },
    { value: "cop", label: "$ Colombian Peso" },
    { value: "pen", label: "S/. Peruvian Sol" },
    { value: "uah", label: "₴ Ukrainian Hryvnia" },
    { value: "egp", label: "£ Egyptian Pound" },
    { value: "sar", label: "ر.س Saudi Riyal" },
    { value: "aed", label: "د.إ UAE Dirham" },
    { value: "vnd", label: "₫ Vietnamese Dong" },
    { value: "kes", label: "KSh Kenyan Shilling" },
    { value: "ngn", label: "₦ Nigerian Naira" },
    { value: "pkr", label: "₨ Pakistani Rupee" },
    { value: "ghs", label: "₵ Ghanaian Cedi" },
    { value: "ugx", label: "USh Ugandan Shilling" },
    { value: "bdt", label: "৳ Bangladeshi Taka" },
    { value: "qar", label: "ر.ق Qatari Riyal" },
    { value: "lbp", label: "ل.ل Lebanese Pound" },
    { value: "mad", label: "د.م. Moroccan Dirham" },
    { value: "cup", label: "$ Cuban Peso" },
    { value: "crc", label: "₡ Costa Rican Colón" },
    { value: "npr", label: "₨ Nepalese Rupee" },
    { value: "hnl", label: "L Honduran Lempira" },
    { value: "gtq", label: "Q Guatemalan Quetzal" },
    { value: "pab", label: "B/. Panamanian Balboa" },
    { value: "uyu", label: "$U Uruguayan Peso" },
    { value: "bob", label: "Bs. Bolivian Boliviano" },
    { value: "pyg", label: "₲ Paraguayan Guarani" },
    { value: "etb", label: "ብር Ethiopian Birr" },
    { value: "awg", label: "ƒ Aruban Florin" },
    { value: "bsd", label: "$ Bahamian Dollar" },
    { value: "bbd", label: "$ Barbadian Dollar" },
    { value: "bzd", label: "BZ$ Belize Dollar" },
    { value: "bmd", label: "$ Bermudian Dollar" },
    { value: "kyd", label: "$ Cayman Islands Dollar" },
    { value: "fjd", label: "$ Fijian Dollar" },
    { value: "gyd", label: "$ Guyanese Dollar" },
    { value: "jmd", label: "J$ Jamaican Dollar" },
    { value: "lrd", label: "$ Liberian Dollar" },
    { value: "nad", label: "$ Namibian Dollar" },
    { value: "srd", label: "$ Surinamese Dollar" },
    { value: "ttd", label: "TT$ Trinidad and Tobago Dollar" },
    { value: "xcd", label: "$ East Caribbean Dollar" },
    { value: "sbd", label: "$ Solomon Islands Dollar" },
  ];
  const [currencies, setcurrencies] = useState([]);
  useEffect(() => {
    onLoad();
  }, []);
  const onLoad = async () => {
    const { response } = await AppService.saas.fetch_category_pricing({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      let arryadrop = [];
      let arryadrop1 = [];
      response.data.map((item) => {
        arryadrop.push({ label: item.name, value: item._id });
      });
      response.promptslabel.map((item) => {
        arryadrop1.push({ label: item.name, value: item._id });
      });
      setcurrencies(arryadrop);
      setpromplabels(response.promptslabel);
    }
  };
  const handleInputChange = (event) => {
    const tempSliderValue = event.target.value;
    if (tempSliderValue < 1) {
      return true;
    }
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, markupmargin: tempSliderValue },
    });

    const progress = (tempSliderValue / event.target.max) * 100;

    event.target.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
  };

  const handleIsFreeSaas = () => {
    setIsFreeSaas((prevState) => {
      const newValue = !prevState;
      setFormData({
        ...formData,
        is_free_saas: newValue, // Use the updated value here
      });
      return newValue;
    });
  };

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const freePlanExists = data.some((plan) => plan.is_free_saas === true);
      console.log(freePlanExists, "freePlanExists");
      setHasFreeSaasPlan(freePlanExists);
    }
  }, []);

  const switchStyles = {
    container: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      width: "60px",
      height: "30px",
      backgroundColor: formData.external ? "#4CAF50" : "#ccc",
      borderRadius: "30px",
      padding: "5px",
      position: "relative",
      transition: "background-color 0.3s",
    },
    circle: {
      height: "20px",
      width: "20px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      position: "absolute",
      top: "5px",
      left: formData.external ? "35px" : "5px",
      transition: "left 0.3s",
    },
  };

  const switchStylesCustom = {
    container: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      width: "60px",
      height: "30px",
      backgroundColor: formData.custom_redirect ? "#4CAF50" : "#ccc",
      borderRadius: "30px",
      padding: "5px",
      position: "relative",
      transition: "background-color 0.3s",
    },
    circle: {
      height: "20px",
      width: "20px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      position: "absolute",
      top: "5px",
      left: formData.custom_redirect ? "35px" : "5px",
      transition: "left 0.3s",
    },
  };

  return (
    <>
      <div className="container mt-4 sd-plans-edit-form">
        <div className="flex justify-center">
          <div className="w-full lg:w-3/4">
            <div className=" bg-white shadow-lg rounded-lg p-6">
              <div>
                <form>
                  {step === 1 && (
                    <>
                      <div className="text-left mb-4">
                        <label htmlFor="planName" className="block mb-1 text-black">
                          Plan Name
                        </label>
                        <input
                          type="text"
                          id="planName"
                          className="form-control-agust w-full"
                          value={formData.plan.planName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              plan: { ...formData.plan, planName: e.target.value },
                            })
                          }
                        />
                        {errors.planName && (
                          <small className="text-red-500" style={{ fontSize: "14px" }}>
                            {errors.planName}
                          </small>
                        )}
                      </div>
                      <div className="text-left mb-4">
                        <label htmlFor="description" className="block mb-1 text-black">
                          Description
                        </label>
                        <input
                          style={{ width: "100%", border: "1px solid #d8cbcb" }}
                          type="text"
                          id="description"
                          className="form-control-agust   w-full"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              plan: { ...formData.plan, description: e.target.value },
                            })
                          }
                          value={formData.plan.description}
                        />
                        {errors.description && (
                          <small className="text-red-500" style={{ fontSize: "14px" }}>
                            {errors.description}
                          </small>
                        )}
                      </div>
                      <div className="text-left mb-4">
                        <label htmlFor="badge_label" className="block mb-1 text-black">
                          Plan Badge (optional)
                        </label>
                        <input
                          type="text"
                          id="badge_label"
                          className="form-control-agust w-full"
                          placeholder='e.g. "Best value" or "Most affordable"'
                          value={formData.badge_label}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              badge_label: e.target.value,
                            })
                          }
                        />
                        <p style={{ fontSize: "12px", color: "#666", marginTop: 6, marginBottom: 0 }}>
                          Shown as a label on top of this plan card on the pricing page.
                        </p>
                      </div>
                      <div className="d-flex justify-content-between gap-2 mb-4">
                        <div className="text-left" style={{ flex: 1 }}>
                          <label htmlFor="highlight_color" className="block mb-1 text-black">
                            Highlight Border Color
                          </label>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <input
                              type="color"
                              id="highlight_color"
                              value={formData.highlight_color || "#ef4444"}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  highlight_color: e.target.value,
                                })
                              }
                              style={{ width: 40, height: 36, padding: 0, border: "none", cursor: "pointer" }}
                            />
                            <input
                              type="text"
                              className="form-control-agust w-full"
                              placeholder="#ef4444 (optional)"
                              value={formData.highlight_color}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  highlight_color: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="text-left" style={{ flex: 1, marginLeft: 5 }}>
                          <label htmlFor="highlight_bg_color" className="block mb-1 text-black">
                            Highlight Background
                          </label>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <input
                              type="color"
                              id="highlight_bg_color"
                              value={formData.highlight_bg_color || "#fef2f2"}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  highlight_bg_color: e.target.value,
                                })
                              }
                              style={{ width: 40, height: 36, padding: 0, border: "none", cursor: "pointer" }}
                            />
                            <input
                              type="text"
                              className="form-control-agust w-full"
                              placeholder="#fef2f2 (optional)"
                              value={formData.highlight_bg_color}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  highlight_bg_color: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {(formData.highlight_color || formData.highlight_bg_color) && (
                        <p style={{ fontSize: "12px", color: "#666", marginTop: -8, marginBottom: 16 }}>
                          Leave colors empty for a normal card. Clear the text fields to remove highlight.
                          <button
                            type="button"
                            style={{
                              marginLeft: 8,
                              border: "none",
                              background: "transparent",
                              color: "#2563eb",
                              cursor: "pointer",
                              textDecoration: "underline",
                              padding: 0,
                              fontSize: 12,
                            }}
                            onClick={() =>
                              setFormData({
                                ...formData,
                                highlight_color: "",
                                highlight_bg_color: "",
                              })
                            }
                          >
                            Clear highlight
                          </button>
                        </p>
                      )}
                      <div className="text-left mb-4">
                        <SoftTypography
                          className="text-black w-100 d-flex justify-content-between"
                          variant="button"
                          sx={{ fontSize: "14px", fontWeight: "500" }}
                          mt={1}
                        >
                          <label className="w-50 new_dezin_label text-black ">Currency</label>
                          {/* <p
                          className="w-50 text-right new_dezin_label text-black cursor-pointer"
                          onClick={handleAddCategory}
                        >
                          + Add Category
                        </p> */}
                        </SoftTypography>

                        {/* <ReactSelect
                        name="category"
                        className="form-input w-full"
                        value={currencies.find(
                          (item) => item.value === formData.category.categorySelected
                        )}
                        options={currencies}
                        isMultiple={false}
                        onChange={handleSelectChange_of_Category}
                      /> */}

                        <ReactSelect
                          name="currency"
                          className="form-input w-full"
                          options={availableCRNC}
                          isMulti={false}
                          onChange={Change_of_currency}
                          menuPortalTarget={document.body} // Render dropdown outside the modal
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Set z-index for visibility
                          }}
                          defaultValue={availableCRNC.filter(
                            (cur) => cur.value === formData.currency
                          )} // Set default value if needed
                        />
                      </div>

                      {/* {!hasFreeSaasPlan && ( */}
                      {/* <div
                        className="text-left mb-4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          type="checkbox"
                          name="isFreeSaas"
                          onChange={handleIsFreeSaas}
                          value={isFreeSaas}
                          checked={isFreeSaas}
                        />
                        <label
                          htmlFor="email"
                          className="block mb-1 text-black"
                          style={{ marginLeft: "14px" }}
                        >
                          Is it a Free SaaS plan?
                        </label>
                      </div> */}
                      {/* )} */}

                      {!editdata.is_free_saas ? (
                        <div className="d-flex justify-content-between">
                          <div className="text-left mb-4">
                            <label htmlFor="planName" className="block text-black">
                              Monthly Price
                            </label>
                            <input
                              type="number"
                              id="monthly_price"
                              name="monthly_price"
                              min="0"
                              className="form-control-agust w-full"
                              value={
                                formData.pricing.monthly_price === ""
                                  ? 0
                                  : formData.pricing.monthly_price
                              }
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  pricing: {
                                    ...formData.pricing,
                                    monthly_price:
                                      e.target.value === "" ? 0 : Number(e.target.value),
                                  },
                                })
                              }
                            />
                          </div>
                          <div className="mb-4 text-left" style={{ margin: "0px 0px 0px 5px" }}>
                            <label htmlFor="planName" className="text-black">
                              Annual Price
                            </label>
                            <input
                              type="number"
                              id="yearly_price"
                              className="form-control-agust w-full"
                              name="yearly_price"
                              min="0"
                              value={formData.pricing.yearly_price}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  pricing: {
                                    ...formData.pricing,
                                    // Convert to number (removes leading zeros) or default 0
                                    yearly_price:
                                      e.target.value === "" ? 0 : Number(e.target.value),
                                  },
                                })
                              }
                            />
                          </div>
                        </div>
                      ) : null}

                      {formData.pricing.monthly_price || formData.pricing.yearly_price ? (
                        <div style={{ marginTop: "10px" }}>
                          <label>External checkout</label>
                          <div
                            onClick={(e) =>
                              setFormData({ ...formData, external: !formData.external })
                            }
                            style={switchStyles.container}
                          >
                            <div style={switchStyles.circle}></div>
                          </div>
                        </div>
                      ) : null}
                      {formData.external ? (
                        <>
                          {formData.pricing.monthly_price ? (
                            <div className="text-left mb-4">
                              <label htmlFor="description" className="block mb-1 text-black">
                                Monthly Url
                              </label>
                              <input
                                type="text"
                                id="monthly_url"
                                style={{ width: "100%", border: "1px solid #d8cbcb" }}
                                className="form-control-agust   w-full"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    monthly_url: e.target.value,
                                  })
                                }
                                value={formData.monthly_url}
                                required={formData.external && formData.pricing.monthly_price}
                                placeholder="This is required when toggle is ON"
                              />
                              {errors.monthly_url && (
                                <small className="text-red-500" style={{ fontSize: "14px" }}>
                                  {errors.monthly_url}
                                </small>
                              )}
                            </div>
                          ) : null}
                          {formData.pricing.yearly_price ? (
                            <div className="text-left mb-4">
                              <label htmlFor="description" className="block mb-1 text-black">
                                Yearly Url
                              </label>
                              <input
                                type="text"
                                id="yearly_url"
                                style={{ width: "100%", border: "1px solid #d8cbcb" }}
                                className="form-control-agust   w-full"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    yearly_url: e.target.value,
                                  })
                                }
                                value={formData.yearly_url}
                                required={formData.external && formData.pricing.yearly_price}
                                placeholder="This is required when toggle is ON"
                              />
                              {errors.yearly_url && (
                                <small className="text-red-500" style={{ fontSize: "14px" }}>
                                  {errors.yearly_url}
                                </small>
                              )}
                            </div>
                          ) : null}
                        </>
                      ) : null}
                      {!formData.external &&
                      (formData.pricing.monthly_price || formData.pricing.yearly_price) ? (
                        <div style={{ marginTop: "10px" }}>
                          <label>Custom Redirect</label>
                          <div
                            onClick={(e) =>
                              setFormData({
                                ...formData,
                                custom_redirect: !formData.custom_redirect,
                              })
                            }
                            style={switchStylesCustom.container}
                          >
                            <div style={switchStylesCustom.circle}></div>
                          </div>
                        </div>
                      ) : null}
                      {formData.custom_redirect && !formData.external ? (
                        <>
                          <div className="text-left mb-4">
                            <label htmlFor="description" className="block mb-1 text-black">
                              Custom Redirect Url
                            </label>
                            <input
                              type="text"
                              id="custom_redirect_url"
                              style={{ width: "100%", border: "1px solid #d8cbcb" }}
                              className="form-control-agust   w-full"
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  custom_redirect_url: e.target.value,
                                })
                              }
                              value={formData.custom_redirect_url}
                              required={formData.custom_redirect}
                              placeholder="This is required when toggle is ON"
                            />
                            {errors.custom_redirect_url && (
                              <small className="text-red-500" style={{ fontSize: "14px" }}>
                                {errors.custom_redirect_url}
                              </small>
                            )}
                          </div>
                        </>
                      ) : null}
                      {/* <div className="text-left mb-4" style={{ width: "50%" }}>

                      <label htmlFor="planName" className="block text-black">User Limit</label>
                      <input
                        type="number"
                        id="user_limit"
                        className="form-control-agust  w-full"
                        name="user_limit"
                        value={formData.pricing.user_limit}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            pricing: { ...formData.pricing, user_limit: e.target.value },
                          })
                        }
                      />

                    </div> */}
                    </>
                  )}
                  {step == 2 && (
                    <>
                      <div
                        className="text-left mb-4"
                        style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}
                      >
                        <p className=" text-black font-15">
                          Select the features you’d like to enable for this plan.{" "}
                          <strong>Included</strong> sets ✓ or ✗ on the pricing table;{" "}
                          <strong>Show</strong> hides the whole row when off.
                        </p>
                        <div
                          style={{
                            border: "1px solid #e5e5e5",
                            borderRadius: "8px",
                            overflow: "visible",
                            background: "#fff",
                          }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "28px minmax(0, 1fr) 48px 48px",
                              alignItems: "center",
                              columnGap: "4px",
                              padding: "8px 8px",
                              background: "#f4f4f5",
                              borderBottom: "1px solid #e5e5e5",
                              fontSize: "11px",
                              fontWeight: 600,
                              color: "#27272a",
                            }}
                          >
                            <span aria-hidden="true" />
                            <span style={{ alignSelf: "center" }}>Feature</span>
                            <span
                              style={{
                                display: "block",
                                textAlign: "center",
                                borderLeft: "1px solid #d4d4d8",
                                paddingLeft: "2px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Included
                            </span>
                            <span
                              style={{
                                display: "block",
                                textAlign: "center",
                                borderLeft: "1px solid #d4d4d8",
                                paddingLeft: "2px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Show
                            </span>
                          </div>
                          {formData.features.map((feature, index) => (
                            <div
                              key={feature._id || feature.name}
                              style={{
                                display: "grid",
                                gridTemplateColumns: "28px minmax(0, 1fr) 48px 48px",
                                alignItems: "center",
                                columnGap: "4px",
                                padding: "6px 8px",
                                borderBottom:
                                  index < formData.features.length - 1
                                    ? "1px solid #f0f0f0"
                                    : "none",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  type="button"
                                  disabled={index === 0}
                                  onClick={() => moveFeature(index, index - 1)}
                                  className="text-gray-500 hover:text-black"
                                  style={{
                                    padding: "2px",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    lineHeight: 1,
                                  }}
                                >
                                  <IoIosArrowUp />
                                </button>
                                <button
                                  type="button"
                                  disabled={index === formData.features.length - 1}
                                  onClick={() => moveFeature(index, index + 1)}
                                  className="text-gray-500 hover:text-black"
                                  style={{
                                    padding: "2px",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    lineHeight: 1,
                                  }}
                                >
                                  <IoIosArrowDown />
                                </button>
                              </div>
                              <div
                                className="d-flex align-items-center gap-2"
                                style={{ minWidth: 0 }}
                              >
                                <p
                                  className="font-16 text-black mb-0"
                                  style={{ flex: 1, minWidth: 0 }}
                                >
                                  {feature?.showName ||
                                    (feature.name == "Featured Image"
                                      ? "Profile Image"
                                      : feature.name == "Company Logo"
                                      ? "Cover Image"
                                      : feature.name === "Reviews"
                                      ? "Site Reviews "
                                      : feature.name == "Video"
                                      ? "Video Embed"
                                      : feature.name == "Additional Details"
                                      ? "Additional Images "
                                      : feature.name)}{" "}
                                  (
                                  {feature.name == "Featured Image"
                                    ? "Profile Image"
                                    : feature.name == "Company Logo"
                                    ? "Cover Image"
                                    : feature.name === "Reviews"
                                    ? "Site Reviews "
                                    : feature.name == "Video"
                                    ? "Video Embed"
                                    : feature.name == "Additional Details"
                                    ? "Additional Images "
                                    : feature.name}
                                  )
                                </p>
                                {!feature._id && (
                                  <button
                                    type="button"
                                    onClick={() => openEditFeatureModal(index)}
                                    style={{
                                      background: "transparent",
                                      border: "none",
                                      cursor: "pointer",
                                      color: "#777",
                                      flexShrink: 0,
                                    }}
                                  >
                                    ✏️
                                  </button>
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderLeft: "1px solid #f0f0f0",
                                  width: "100%",
                                  minHeight: 36,
                                  padding: 0,
                                  overflow: "visible",
                                }}
                              >
                                <Switch
                                  checked={feature.value}
                                  onChange={() => handleToggleFeature(index)}
                                  color="primary"
                                  sx={{ margin: 0, flexShrink: 0 }}
                                  inputProps={{ "aria-label": "Included in plan" }}
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderLeft: "1px solid #f0f0f0",
                                  width: "100%",
                                  minHeight: 36,
                                  padding: 0,
                                  overflow: "visible",
                                }}
                              >
                                <Switch
                                  checked={feature.showInPlan !== false}
                                  onChange={() => handleToggleShowInPlan(index)}
                                  color="primary"
                                  sx={{
                                    margin: 0,
                                    flexShrink: 0,
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#374151",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                      backgroundColor: "#4b5563",
                                      opacity: 1,
                                    },
                                  }}
                                  inputProps={{ "aria-label": "Show row on pricing table" }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                  {step === 3 && (
                    <>
                      <div className="text-left mb-4">
                        <div className="margin-top-10px">
                          <h2 className="text-black font-16">Trial period</h2>
                          <p className="font-15">
                            Enter the number of days for which a trial can be used.{" "}
                          </p>
                          <input
                            type="number"
                            className="margin-top-10px form-control-agust"
                            min="1"
                            max="100"
                            value={formData.trial_and_credit.days}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                trial_and_credit: {
                                  ...formData.trial_and_credit,
                                  days: e.target.value,
                                },
                              });
                            }}
                            style={{ width: "50%" }}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="d-flex mt-6" style={{ justifyContent: "space-between" }}>
                    <PrimaryButton
                      type="button"
                      className="sd-primary-btn--outline"
                      style={{ marginTop: "10px", width: "40%" }}
                      onClick={() => handleCustomTab()}
                    >
                      Back
                    </PrimaryButton>

                    {step < 3 && (
                      <PrimaryButton
                        type="button"
                        style={{ marginTop: "10px", width: "40%" }}
                        onClick={handleNext}
                      >
                        Next
                      </PrimaryButton>
                    )}
                    {step === 3 && (
                      <PrimaryButton
                        type="button"
                        style={{ marginTop: "10px", width: "40%" }}
                        onClick={handleFormSubmit}
                        disabled={loader}
                      >
                        {loader ? "Waiting..." : "Submit"}
                      </PrimaryButton>
                    )}
                  </div>
                </form>
              </div>
              <div
                className="d-flex  justify-content-between"
                style={{ width: "100%", marginTop: "15px", marginLeft: "15px" }}
              >
                <span className={step === 1 ? "color-active-new" : "color-inactive-new"}></span>

                <div
                  className={1 < step ? "color-active-border-new" : "color-inactive-border-new"}
                  style={{ width: "25%" }}
                ></div>
                <span className={step === 2 ? "color-active-new" : "color-inactive-new"}></span>

                <div
                  className={2 < step ? "color-active-border-new" : "color-inactive-border-new"}
                  style={{ width: "25%" }}
                ></div>
                <span className={step === 3 ? "color-active-new" : "color-inactive-new"}></span>
                <div
                  className={3 < step ? "color-active-border-new" : "color-inactive-border-new"}
                  style={{ width: "25%" }}
                ></div>

                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCustomTab(4)}
                  className={step === 4 ? "color-active-new" : "color-inactive-new"}
                ></span>
              </div>
            </div>
          </div>
        </div>

        {addCategoryModel && (
          <div className="modal-zz-confirm text-left">
            <div
              className="scrollable-modal-content bg-white rounded"
              style={{ position: "relative" }}
            >
              <h2 className="text-black text-left font-14" style={{ marginBottom: "10px" }}>
                Add New Category
              </h2>
              <span className="crossison" onClick={() => setAddCategoryModel(false)}>
                X
              </span>
              <input
                type="text"
                id="category"
                className="form-control-agust w-full"
                name="category"
                placeholder={"Enter Category Name "}
                value={categoryFormData.category}
                onChange={(e) =>
                  setCategoryFormData({
                    ...categoryFormData,
                    name: e.target.value,
                  })
                }
              />
              <div style={{ margin: "10px 0px" }}>
                <ReactSelect
                  className="form-input w-full"
                  options={availableCRNC}
                  isMulti={false}
                  onChange={Change_of_currency}
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Set z-index for visibility
                  }}
                />
              </div>
              <div className="w-100 margin-top-20px">
                <PrimaryButton type="button" style={{ width: "100%" }} onClick={savecategory}>
                  Save
                </PrimaryButton>
              </div>
            </div>
          </div>
        )}
      </div>
      {editFeatureModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div style={{ background: "#fff", padding: 20, borderRadius: 8, width: 450 }}>
            <h5>Edit Feature Name</h5>

            <input
              type="text"
              className="form-control"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
              value={tempFeatureName}
              onChange={(e) => setTempFeatureName(e.target.value)}
            />

            <label className="d-block mt-6 mb-1 text-black">Description</label>
            <textarea
              className="form-control"
              rows={3}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                resize: "vertical",
              }}
              value={tempFeatureDescription}
              onChange={(e) => setTempFeatureDescription(e.target.value)}
            />

            <div className="d-flex mt-6" style={{ justifyContent: "space-between" }}>
              <PrimaryButton
                type="button"
                className="sd-primary-btn--outline"
                style={{ marginTop: "10px", width: "40%" }}
                onClick={() => setEditFeatureModal(false)}
              >
                Cancel
              </PrimaryButton>
              <PrimaryButton
                type="button"
                style={{ marginTop: "10px", width: "40%" }}
                onClick={saveFeatureName}
              >
                Save
              </PrimaryButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfigrationForm;
